import React from 'react';
import { useRequest } from 'hooks';
import { useParams } from 'react-router-dom';

import Category from 'components/Ui/Category';
import { Form, Button, Textarea } from 'components/Misc/Form';

import { useGradeReportStore } from 'store/grade/useGradeReportStore';

const Settings = ({ studentId, report }) => {
	// Cache current grade's id
	const { id } = useParams();

	// Store create and update requests
	const [[createProgress], requestCreate] = useRequest('post', 'reports');
	const [[updateProgress], requestUpdate] = useRequest('put', `reports/${report.id}`);

	// Use grade report store
	const [onChangeReport, onUpdateReport] = useGradeReportStore(state => [
		state.onChangeReport,
		state.onUpdateReport
	]);

	// Handle input's value change
	const onChange = (change) => onChangeReport(studentId, change);

	// Handle report's creation or update
	const onSubmit = async (event) => {
		event.preventDefault();

		// Try to create or update data
		const [success] = report.id
			? await requestUpdate(report)
			: await requestCreate({
				...report,
				gradeId: id,
				studentId
			});

		// Update report's data
		if (success) onUpdateReport(success.report);
	};

	return (
		<Category title="Iestatījumi" hide>
			<Form onSubmit={onSubmit} className="flex flex-col gap-4">
				<Textarea
					name="warrant"
					label="Rīkojums"
					value={report.warrant}
					onChange={onChange}
				/>

				<Textarea
					name="achievement"
					label="Sasniegumi"
					value={report.achievement}
					onChange={onChange}
				/>

				<div className="flex justify-end items-end">
					<Button
						submit
						icon="done"
						value="Saglabāt"
						theme="success"
						progress={createProgress || updateProgress}
					/>
				</div>
			</Form>
		</Category>
	);
};

export default Settings;